export default __webpack_public_path__ + "static/media/IMPERIUM-FINANCE.2f707958.png";